module.exports = "/_next/static/images/loading_21-6f85801dfb153c6079e8cf71845ba189.png";